import { animateHitFlash } from './ui/animator.js';

export function onBossFire(game, boss, { intensityScale = 1 } = {}) {
  if (!boss || !game.player) return;
  const isFinal = boss.phase === 2;
  game.cameraRig.shakeImpactGsap({
    intensity: (isFinal ? 0.13 : 0.08) * intensityScale,
    duration: isFinal ? 0.2 : 0.16,
    dirX: boss.aimX,
    dirZ: boss.aimZ,
  });
}

export function flashHit(game) {
  animateHitFlash(game._hitFlashEl);
}

export function onPlayerDeath(game) {
  game.spawnManager?.stop();
  game.state = 'gameover';
  setTimeout(() => game.menuCtl.showGameOver(game.roomIndex + 1), 700);
  game.audio.stopMusic();
}

export function onEnemyKilled(game, enemy) {
  game.cameraRig.punchZoom(0.45, 0.16);
  if (game.player.getTotalReserveAmmo() < game.player.getTotalReserveCapacity() && game.rng() < 0.35) {
    const amount = 4 + Math.floor(game.rng() * 5); // 4-8 reserve bullets
    game._spawnAmmoPickup(enemy.x, enemy.z, amount);
  }
  const result = game.player.onKill(game);
  if (result?.explosive) {
    // Drop a shard at enemy position
    game._spawnShard(enemy.x, enemy.z);
  }
}


